import React from "react";
import { Paper, Typography, Box, Chip } from "@mui/material";
import { Description as ReportIcon } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { MarkdownContentBox } from "../../../components/common/MarkdownContentBox";
import { ResearchMode } from "../types";
import ScrollableBox from "../../../components/common/ScrollableBox";
import CopyButtonOrIcon from "../../../components/common/CopyButtonOrIcon";

interface FinalReportCardProps {
  finalReport: string;
  status: string;
  researchMode?: ResearchMode;
}

export const FinalReportCard: React.FC<FinalReportCardProps> = ({ finalReport, status, researchMode }) => {
  const { t } = useTranslation();

  if (status !== "completed" || !finalReport) return null;

  // 調査モードの表示テキスト
  const getModeDisplayText = (mode?: ResearchMode): string => {
    switch (mode) {
      case "detailed":
        return t("deepResearch.researchMode.detailed");
      case "fast":
        return t("deepResearch.researchMode.fast");
      default:
        return "";
    }
  };

  const modeDisplayText = getModeDisplayText(researchMode);

  return (
    <Paper sx={{ display: "flex", height: "100%", flexDirection: "column", overflow: "hidden" }}>
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 2, px: 3, pt: 3 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <ReportIcon color="primary" />
            <Typography variant="h6">{t("deepResearch.progress.finalReport")}</Typography>
          </Box>
          {modeDisplayText && (
            <Chip
              label={modeDisplayText}
              size="small"
              color={researchMode === "detailed" ? "primary" : "secondary"}
              variant="outlined"
            />
          )}
        </Box>
        <CopyButtonOrIcon displayType="icon" textToCopy={finalReport} size="small" placement="left" />
      </Box>

      <ScrollableBox sx={{ display: "flex" }}>
        <Box sx={{ px: 3, pb: 3 }}>
          <MarkdownContentBox>{finalReport}</MarkdownContentBox>
        </Box>
      </ScrollableBox>
    </Paper>
  );
};
